import React from "react";
import { registerTeaserWebComponent, renderServerSide, ITeaserProps, TeaserRegion } from "@talkfurther/elements";
import { version as REACT_VERSION } from "./package.json";

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      "further-teaser": any;
    }
  }
}

interface TeaserComponentProps extends ITeaserProps {
  region?: TeaserRegion;
}

interface TeaserComponentState {
  isClient: boolean;
}

export class Teaser extends React.Component<TeaserComponentProps, TeaserComponentState> {
  constructor(props: TeaserComponentProps) {
    super(props);
    this.state = { isClient: false };
  }

  componentDidMount() {
    // componentDidMount only runs in the client,
    // so when it runs, we know for sure it's client-side
    this.setState({ isClient: true });
    const { region } = this.props;
    registerTeaserWebComponent({ region });
  }

  render() {
    const props = this.props;
    const { isClient } = this.state;
    const html = isClient ? "" : renderServerSide(props);

    return (
      <further-teaser
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{ __html: html }}
        vsa-instance={props.vsaInstance}
        data-sdk-framework="react"
        data-sdk-react-version={REACT_VERSION}
        title={props.title}
        subtitle={props.subtitle}
        options={JSON.stringify(props.options)}
        show-recent-tour-inquiries={props.showRecentTourInquiries}
        theme={JSON.stringify(props.theme || {})}
        custom-css={props.customCss}
      ></further-teaser>
    );
  }
}

export default Teaser;
